"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
var _consts = require("../utils/consts");
var CopiedProjectUtil = _interopRequireWildcard(require("../utils/copiedProject"));
var LocaleUtil = _interopRequireWildcard(require("../utils/locales"));
var _excluded = ["name"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` Copied Project Service
 */
var CopiedProject = /*#__PURE__*/function (_Base) {
  /**
   * Create copied project service instance
   *
   * @param sdk - the SDK instance
   */
  function CopiedProject(sdk) {
    (0, _classCallCheck2["default"])(this, CopiedProject);
    return _callSuper(this, CopiedProject, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(CopiedProject, _Base);
  return (0, _createClass2["default"])(CopiedProject, [{
    key: "skipCopyDocuments",
    value: (
    /**
     * Skip copy project documents
     * https://platform.stoplight.autodesk.com/docs/docs-cp/b261a0548a57e-resume-copy-project
     *
     * @param projectId - , is the project id
     * @param payload -, request payload, empty by default
     * @param config -  Configurable object for overwrite request parameters.
     * @returns results and errors
     */
    function () {
      var _skipCopyDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              url = "/projects/".concat(projectId, "/copied-project/files:resume-copy");
              _context.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context.sent;
              return _context.abrupt("return", res.data);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function skipCopyDocuments(_x, _x2, _x3) {
        return _skipCopyDocuments.apply(this, arguments);
      }
      return skipCopyDocuments;
    }()
    /**
     * Get copy failed project documents with pagination.
     * https://platform.stoplight.autodesk.com/docs/docs-cp/2e49bf563070f-list-copied-files
     *
     * @param projectId - , is the project id
     * @param params - with the shape of \{ offset, limit \}
     * @param config -  Configurable object for overwrite request parameters..
     * @returns results and pagination
     */
    )
  }, {
    key: "getFailedDocuments",
    value: (function () {
      var _getFailedDocuments = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = _qs["default"].stringify((0, _extends2["default"])({
                filter: {
                  status: 'FAILED'
                }
              }, params), {
                addQueryPrefix: true,
                encode: false
              });
              url = "/projects/".concat(projectId, "/copied-project/files").concat(query);
              _context2.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context2.sent;
              return _context2.abrupt("return", res.data);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getFailedDocuments(_x4, _x5, _x6) {
        return _getFailedDocuments.apply(this, arguments);
      }
      return getFailedDocuments;
    }()
    /**
     * Get project copy details through command id.
     * https://wiki.autodesk.com/display/PDCA/Copy+Project+With+Partial+Role
     *
     * @param projectId - is the project uuid.
     * @param commandId - is the command uuid.
     * @param params - the query params with the shape of
     *                          \{ offset, limit, resource: 'ROLE' / 'FOLDER / 'CUSTOMATTRIBUTE' \}
     * @param config -  Configurable object for overwrite request parameters..
     * @returns the copy details with the shape of \{ results: [], pagination: \{\} \}
     */
    )
  }, {
    key: "getCopyDetails",
    value: (function () {
      var _getCopyDetails = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, commandId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/commands/").concat(commandId, "/copy-details").concat(query);
              _context3.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context3.sent;
              if (!((params === null || params === void 0 ? void 0 : params.resource) !== 'ROLE')) {
                _context3.next = 7;
                break;
              }
              return _context3.abrupt("return", res.data);
            case 7:
              return _context3.abrupt("return", {
                pagination: res.data.pagination,
                results: res.data.results.map(function (_ref) {
                  var name = _ref.name,
                    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
                  return (0, _extends2["default"])({}, rest, {
                    name: LocaleUtil.translate("userRoles.".concat((0, _snakeCase["default"])(name)), name)
                  });
                })
              });
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getCopyDetails(_x7, _x8, _x9, _x10) {
        return _getCopyDetails.apply(this, arguments);
      }
      return getCopyDetails;
    }()
    /**
     * Get copied naming standards info
     * https://platform.stoplight.autodesk.com/docs/docs-cp/e49c3d1da0298-list-copied-naming-standards
     *
     * @param projectId - the project id
     * @param params - query with shape of \{ status \}
     * @param config - configurable object for overwrite request parameters
     */
    )
  }, {
    key: "getCopiedNamingStandards",
    value: (function () {
      var _getCopiedNamingStandards = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              url = "/projects/".concat(projectId, "/copied-project/naming-standards").concat(query);
              _context4.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context4.sent;
              return _context4.abrupt("return", res.data);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getCopiedNamingStandards(_x11, _x12, _x13) {
        return _getCopiedNamingStandards.apply(this, arguments);
      }
      return getCopiedNamingStandards;
    }()
    /**
     * Resume copy step
     * https://platform.stoplight.autodesk.com/docs/docs-cp/2387adbceb6bc-resume-copy-project-copy-naming-standards
     *
     * @param projectId - the project id
     * @param payload - request payload with shape of \{ stepName, action \}
     * @param config -  configurable object for overwrite request parameters
     */
    )
  }, {
    key: "resumeCopyStep",
    value: (function () {
      var _resumeCopyStep = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, payload, config) {
        var url, res;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              url = "/projects/".concat(projectId, "/copied-project/copy-steps:resume-copy");
              _context5.next = 3;
              return this.HttpService.dmV3.post(url, payload, config);
            case 3:
              res = _context5.sent;
              return _context5.abrupt("return", res.data);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function resumeCopyStep(_x14, _x15, _x16) {
        return _resumeCopyStep.apply(this, arguments);
      }
      return resumeCopyStep;
    }()
    /**
     * Get sheets copy info
     * https://wiki.autodesk.com/pages/viewpage.action?spaceKey=PDCA&title=080+-+Copy+Sheet+Permission+From+The+Template
     *
     * @param projectId - the project id
     * @param params - query parameters with shape of \{ sheetContainerType \}
     * @param config -  conf Configurable object for overwrite request parameters
     */
    )
  }, {
    key: "getSheetsCopyInfo",
    value: (function () {
      var _getSheetsCopyInfo = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              query = _qs["default"].stringify((0, _extends2["default"])({
                sheetContainerType: _consts.SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/sheet-containers/".concat(projectId, "/copy-status").concat(query);
              _context6.next = 4;
              return this.HttpService.dmV3.get(url, config);
            case 4:
              res = _context6.sent;
              return _context6.abrupt("return", CopiedProjectUtil.parseSheetsCopyInfo(res.data));
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getSheetsCopyInfo(_x17, _x18, _x19) {
        return _getSheetsCopyInfo.apply(this, arguments);
      }
      return getSheetsCopyInfo;
    }()
    /**
     * Resume copy sheets
     * https://wiki.autodesk.com/pages/viewpage.action?spaceKey=PDCA&title=080+-+Copy+Sheet+Permission+From+The+Template
     *
     * @param projectId - the project id
     * @param payload - request payload with shape of \{ action \}
     * @param params - query parameters with shape of \{ sheetContainerType \}
     * @param config -  conf Configurable object for overwrite request parameters
     */
    )
  }, {
    key: "resumeCopySheets",
    value: (function () {
      var _resumeCopySheets = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(projectId, payload, params, config) {
        var query, url, res;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              query = _qs["default"].stringify((0, _extends2["default"])({
                sheetContainerType: _consts.SHEETS_CONTAINER_TYPES.BUILD
              }, params), {
                addQueryPrefix: true
              });
              url = "/sheet-containers/".concat(projectId, "/resume-copy").concat(query);
              _context7.next = 4;
              return this.HttpService.dmV3.post(url, payload, config);
            case 4:
              res = _context7.sent;
              return _context7.abrupt("return", res.data);
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function resumeCopySheets(_x20, _x21, _x22, _x23) {
        return _resumeCopySheets.apply(this, arguments);
      }
      return resumeCopySheets;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'CopiedProject';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = CopiedProject;